"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VariantSwitch = /** @class */ (function () {
    function VariantSwitch() {
        this.elem = {
            productJson: document.querySelectorAll('[id^="ProductJson-"]'),
            dispatchElem: document.querySelectorAll('.product-options__option'),
            itrElem: document.querySelector('.product-options__option')
        };
    }
    VariantSwitch.prototype.init = function () {
        var eventElemCheck = document.getElementsByClassName('product-options__option');
        if (eventElemCheck.length > 0) {
            this.addEventListeners();
        }
    };
    VariantSwitch.prototype.addEventListeners = function () {
        var self = this;
        self.elem.dispatchElem.forEach(function (el) {
            el.addEventListener('change', function () {
                self.fireTheEventInit();
            });
        });
    };
    VariantSwitch.prototype.getConcateVariantVal = function () {
        var combineVariantVal = "", itrElem = document.querySelector('.product-options__option');
        if (this.elem.dispatchElem.length > 1) {
            this.elem.dispatchElem.forEach(function (item) {
                combineVariantVal += item.value + " / ";
            });
        }
        else {
            combineVariantVal = itrElem.value + " / ";
        }
        return combineVariantVal;
    };
    VariantSwitch.prototype.functiontofindIndexByKeyValue = function (arraytosearch, key, valuetosearch) {
        for (var i = 0; i < arraytosearch.length; i++) {
            if (arraytosearch[i][key] == valuetosearch) {
                return i;
            }
        }
        return null;
    };
    VariantSwitch.prototype.mediaChange = function (productObject, index) {
        if (productObject.variants[index].featured_image) {
            var mediaId = productObject.variants[index].featured_media['id'];
            var imageIndex = this.functiontofindIndexByKeyValue(productObject.media, "id", mediaId);
            var parentScrollElem = document.querySelectorAll('div.gallery__grid .gallery__grid-item')[imageIndex];
            parentScrollElem.scrollIntoView({ behavior: 'smooth' });
        }
        else {
            var parentScrollElem = document.querySelectorAll('div.gallery__grid .gallery__grid-item')[0];
            parentScrollElem.scrollIntoView({ behavior: 'smooth' });
        }
    };
    VariantSwitch.prototype.fireTheEventInit = function () {
        var productObject = JSON.parse(this.elem.productJson[0].innerHTML);
        var variantHiddenVal = document.querySelector('.btn-add-to-bag__form input[type="hidden"]'), featuredImage = document.querySelector('.gallery__grid .gallery__grid-item:first-child img'), completeVariantVal = document.querySelectorAll('#ProductSelect--product option'), variantId = 0;
        ;
        var variantIndex = variantHiddenVal.value;
        if (variantIndex) {
            var index = this.functiontofindIndexByKeyValue(productObject.variants, "id", variantIndex);
            this.mediaChange(productObject, index);
        }
        else {
            var matchParam = this.getConcateVariantVal();
            if (matchParam) {
                completeVariantVal.forEach(function (item) {
                    if (matchParam.trim() === item.text.trim()) {
                        variantId = item.value;
                    }
                });
            }
            var index = this.functiontofindIndexByKeyValue(productObject.variants, "id", variantId);
            this.mediaChange(productObject, index);
        }
    };
    return VariantSwitch;
}());
exports.default = new VariantSwitch();
